import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { timeout } from 'rxjs/operators';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { HttpService } from 'src/app/_provider/http.service';

@Component({
  selector: 'app-no-connection',
  templateUrl: './no-connection.page.html',
  styleUrls: ['./no-connection.page.scss'],
})
export class NoConnectionPage implements OnInit {

  constructor(
    public darkmode: DarkmodeService,
    private modalCtrl: ModalController,
    private feedback: FeedbackService,
    private http: HttpService
  ) { }

  ngOnInit() {
  }

  public async checkConnection(){
    await this.feedback.updateLoading("Prüfe Verbindung...")

    const respone: HttpFunctionResult<any> = await this.http.GET<any>({
      path: "",
      timeout: 8000,
    })
    await this.feedback.hideLoading()
    if(!respone.success) return
    await this.modalCtrl.dismiss()
  }
}
